module.exports = [{"title":"Grado en Ingeniería Geomática y Topografía","centro":"Universitat Politècnica de València (UPV)","periodo":"2011 - 2016","icon":"school"},{"title":"Máster Geomática y Geoinformación","centro":"Universitat Politècnica de València (UPV)","periodo":"2016 - Actualidad"}]


//////////////////
// WEBPACK FOOTER
// ./src/files/estudios.json
// module id = 270
// module chunks = 1